import { useContext } from "react";

import { actions } from "../context/AppProvider";
import appContext from "../context/appContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import HeModal from "../../../components/HeModal/HeModal";
import HeEPSDownloadReport from "../../../components/HeEPS/DownloadReport";

let downloadFormRef;
const DownloadModal = () => {
    const { state, dispatch } = useContext(appContext);

    if (state.selectedGeos.length === 0) return null;
    return (
        <HeModal
            className="app"
            headerText="Download Report"
            headerFontAwesomeIcon={<FontAwesomeIcon icon={faFileDownload} style={{ color: "#367ebd" }} />}
            isOpen={state.isDownloadModalOpen}
            onCloseRequest={() => dispatch({ type: actions.SET_IS_DOWNLOAD_MODAL_OPEN, to: false })}
            onDownloadRequest={() => {
                downloadFormRef.submitViaCors();
            }}
            buttonClass="app_button"
            content={
                <div className="app reportrequest">
                    <HeEPSDownloadReport
                        disabled={state.selectedGeos.length === 0}
                        TemplateName={"fs"}
                        requestSource="usfs-indicators"
                        excelOnly={state.selectedGeos.length > 5}
                        Group1_geoCodes={state.selectedGeos.map((geo) => {
                            return geo.id;
                        })}
                        Group1_Aggregate={false}
                        Group1_Region={false}
                        Group1_Benchmark={false}
                        Group2_overrideName={
                            state.selectedGeos.length === 1 ? state.selectedGeos[0].label : "Combined counties"
                        }
                        Group3_overrideName={state.benchmarkName}
                        printFormat="pdf"
                        defaultTitle="USFS Socioeconomic Profile"
                        // defaultSubTitle={this.state.selectedGeos.length === 1 ? this.state.selectedGeos[0].label : "Selected " + find(geoLayers, { id: this.state.visibleGeoLayer }).label}
                        defaultSubTitle={state.searchFeature.label}
                        onRef={(ref) => (downloadFormRef = ref)}
                        benchmarkGeo={state.benchmarkGeo}
                        onBenchmarkGeoUpdate={(newVal) => {
                            dispatch({ type: actions.SET_BENCHMARK_TO, to: newVal });
                        }}
                        hideSubtitleField={true}
                    />
                </div>
            }
        />
    );
};
export default DownloadModal;
